import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "../../../hooks";
import { theme } from "../../core/tokens";
import { Button } from "../Button";
import DropModal from "./DropModal";
import { Content, Portal, Root, Trigger } from "./styles";
import { useLocation } from "react-router-dom";
export function Dropdown({ children, triggerContent, mobileFull, desktopFull, side = "top", offset, onOpenChange, align = "start", disabled = false, isMenuButton = false, expanded, useExpanded, colorButton, radiusFullDesktop, "trigger-data-testid": triggerDataTestId, abReference, }) {
    const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.medium})`);
    const modalRef = useRef(null);
    const [userABType, setUserABType] = useState("B");
    const location = useLocation();
    useEffect(() => {
        if ((location.pathname.includes("minhas-farmacias") || location.pathname.includes("meu-perfil")) &&
            !location.pathname.includes("minhas-farmacias/pedidos")) {
            setUserABType("A");
        }
        else {
            setUserABType("");
        }
    }, [location.pathname]);
    if (mobileFull && !isDesktop)
        return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "text", onClick: () => {
                        modalRef.current?.handleOpen();
                        onOpenChange?.();
                    }, disabled: disabled, children: triggerContent }), _jsx(DropModal, { ref: modalRef, alignment: "left", colorButtonClose: colorButton, children: children })] }));
    return (_jsx(Root, { "data-reference": abReference || "", "data-ABtest": "user-menu", "data-reference-menu": userABType || "", children: _jsxs(DropdownMenu.Root, { ...(useExpanded ? { open: expanded } : {}), onOpenChange: onOpenChange, children: [_jsx(Trigger, { "data-testid": triggerDataTestId, isMenuButton: isMenuButton, disabled: disabled, children: triggerContent }), _jsx(Portal, { children: _jsx(Content, { side: side, desktopFull: desktopFull, align: align, sideOffset: offset, radiusFullDesktop: radiusFullDesktop, children: children }) })] }) }));
}
//# sourceMappingURL=index.js.map